export default "__VITE_ASSET__1dwq7cXG__"